import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { IServiceChangeRequest } from '../../../../core/models/service-change-request.model';
import { EServiceChangeRequestReviewSection } from '../../../../core/models/service-change-request-review-issue.model';
import { IServiceRequestPricing } from '../../../../core/models/service-pricing.model';
import { IServiceTemplate } from '../../../../core/models/service-template/service-template.model';

@Component({
  selector: 'irembogov-template-preview-pricing',
  templateUrl: './template-preview-pricing.component.html',
  styleUrls: ['./template-preview-pricing.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TemplatePreviewPricingComponent implements OnChanges {
  @Input() pricingData!: Record<string, unknown>;

  serviceRequestPricing!: IServiceRequestPricing;

  EServiceChangeRequestReviewSection = EServiceChangeRequestReviewSection;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pricingData']?.currentValue) {
      this.serviceRequestPricing = changes['pricingData'].currentValue;
    }
  }
}
